import { BriefType } from "../../../constants/types";
import { IPermissions } from "../../../types/user/permissions/ipermissions/ipermissions.interface";

import { OtisForm } from "../../forms/forms.hook";

export const pageType = BriefType.EXECUTION_BRIEF;

export interface IExecutionBriefTemplate {
  form: OtisForm<any>;
  pageTitle?: string;
  resourceId: number;
  resourceType: string;
  userPermissions: IPermissions;
}

export { ExecutionBriefSimpleTemplate } from "./simple";
export { ExecutionBriefWebTemplate } from "./web";
export { ExecutionBriefDealerAdvertisingTemplate } from "./dealerAdvertising";
export { ExecutionBriefInStorePrintTemplate } from "./inStorePrint";
export { ExecutionBriefInStoreDigitalTemplate } from "./inStoreDigital";
export { ExecutionBriefPaidMediaTemplate } from "./paidMedia";
export { ExecutionBriefEdmTemplate } from "./edm";
